import { render, staticRenderFns } from "./BillingPlan.vue?vue&type=template&id=694577e0"
import script from "./BillingPlan.vue?vue&type=script&lang=js"
export * from "./BillingPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('694577e0')) {
      api.createRecord('694577e0', component.options)
    } else {
      api.reload('694577e0', component.options)
    }
    module.hot.accept("./BillingPlan.vue?vue&type=template&id=694577e0", function () {
      api.rerender('694577e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/BillingPlan.vue"
export default component.exports